import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Pencil, Plus, Repeat, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { brl } from "@/lib/format";
import { Button, Card } from "@/components/kit";
import { ExpenseDialog } from "@/components/dre/ExpenseDialog";

function Row({ e, groups, onEdit, month }) {
  const qc = useQueryClient();
  const del = useMutation({
    mutationFn: () => api(`/dre/expenses/${e.id}?month=${month}`, { method: "DELETE" }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["dre"] }); toast.success(e.kind === "fixa" ? "Despesa fixa encerrada a partir deste mês" : "Lançamento excluído"); },
    onError: (err) => toast.error(err.message),
  });
  const ask = () => window.confirm(e.kind === "fixa" ? "Encerrar esta despesa fixa a partir deste mês? Os meses anteriores continuam com ela." : "Excluir este lançamento?") && del.mutate();
  return (
    <div className="flex items-center gap-3 px-4 py-3" data-testid={`dre-expense-row-${e.id}`}>
      <div className="flex-1 min-w-0">
        <div className="label truncate flex items-center gap-1.5">{e.kind === "fixa" && <Repeat size={13} className="shrink-0" title="Fixa" style={{ color: "var(--brand)" }} />}<span className="truncate">{e.name}</span></div>
        <div className="caption truncate">{groups[e.group]}{e.override_id ? " · valor ajustado neste mês" : ""}</div>
      </div>
      <span className="tnum font-semibold" style={{ color: e.group === "outras_receitas" ? "var(--success, #2f7d4f)" : undefined }}>{brl(e.amount)}</span>
      <button className="icon-btn" title="Editar" onClick={() => onEdit(e)} data-testid={`dre-expense-edit-${e.id}`}><Pencil size={15} /></button>
      <button className="icon-btn" title="Excluir" onClick={ask} data-testid={`dre-expense-delete-${e.id}`}><Trash2 size={15} /></button>
    </div>
  );
}

export function ExpensesCard({ month, expenses, groups }) {
  const [dialog, setDialog] = useState(null);
  const total = expenses.filter((e) => e.group !== "outras_receitas").reduce((a, e) => a + e.amount, 0);
  return (
    <Card className="flex flex-col gap-3" style={{ padding: 0 }} data-testid="dre-expenses-card">
      <div className="flex items-center gap-3 px-4 pt-4">
        <div className="flex-1"><div className="h3">Despesas e outras receitas</div><div className="caption">Total de despesas no mês: <b className="tnum">{brl(total)}</b></div></div>
        <Button size="sm" icon={Plus} onClick={() => setDialog({})} data-testid="dre-add-expense-button">Lançar</Button>
      </div>
      {expenses.length ? (
        <div className="divide border-t" style={{ borderColor: "var(--border)" }}>{expenses.map((e) => <Row key={e.id} e={e} groups={groups} month={month} onEdit={(x) => setDialog({ expense: x })} />)}</div>
      ) : <p className="caption px-4 pb-4" data-testid="dre-expenses-empty">Nenhuma despesa neste mês. Lance aluguel, salários, energia e outras despesas · as fixas se repetem sozinhas nos próximos meses.</p>}
      {dialog && <ExpenseDialog open onOpenChange={(o) => !o && setDialog(null)} month={month} groups={groups} expense={dialog.expense} />}
    </Card>
  );
}
